import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEditViewStockAudit from "../../../components/inventory/stock-audit/create-edit-view-stock-audit";
import { stockAuditViewAction } from "../../../redux/actions/stock-details-audit-action";

const AddStockAudit = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const cloneId = searchParams.get("cloneId");
  const [audit, setAudit] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cloneId) {
      setLoading(true);
      dispatch(stockAuditViewAction({ sat_id: cloneId }, onSuccess, onError));
    }
  }, [cloneId]);

  const onSuccess = (data) => {
    const cloned = { ...(data?.data || {}) };
    // strip identifiers so the clone is submitted as a brand-new audit
    delete cloned.sat_id;
    delete cloned.sot_id;
    delete cloned.audit_number;
    delete cloned.status;
    cloned.items = (cloned?.items || []).map((item) => {
      const itemCopy = { ...item };
      delete itemCopy.sait_id;
      delete itemCopy.sot_id;
      return itemCopy;
    });
    setAudit(cloned);
    setLoading(false);
  };
  const onError = () => {
    setLoading(false);
  };

  return (
    <InnerLayout backBtn={true} title="Stock Audit">
      <CreateEditViewStockAudit
        disabled={false}
        loading={loading}
        setLoading={setLoading}
        audit={audit}
      />
    </InnerLayout>
  );
};

export default AddStockAudit;
